import fb from '../../firebase'
import { AbilitiesState, FirestoreQuerySnapper, FirestoreSnapperType, RootState } from '../types'
import store, { moduleActionContext, storehelper } from '..'
import { ActionContext } from 'vuex'
import { firestore } from 'firebase'
import { TeamRole } from '@/abilitiesByRole'
import Vue from 'vue'
import { CollectionNames } from '@/types'

type AbilitiesContext = ActionContext<AbilitiesState, RootState>

const abilitiesModule = {
  namespaced: true,
  state: {
    teamRoles: {},
    teamRolesReady: false
  } as AbilitiesState,
  actions: {
    async subscribeTeamRoles (context: AbilitiesContext, teamId: string) {
      const { commit } = abilitiesModuleActionContext(context)
      const snapper: FirestoreQuerySnapper = {
        query: fb.db.collection(CollectionNames.TEAMS_ROLES).where('team_id', '==', teamId).where('deleted', '==', false),
        mutation: commit.updateTeamRoles,
        type: FirestoreSnapperType.Query
      }
      storehelper.subscribe(`teams_roles_${teamId}`, snapper)
    },
    async unsubscribeTeamRoles (_context: AbilitiesContext, teamId: string) {
      storehelper.unsubscribe(`teams_roles_${teamId}`)
    },
    async addRole (_context: AbilitiesContext, role: TeamRole) {
      await fb.db.collection(CollectionNames.TEAMS_ROLES).add(role.toJSON())
    },
    async updateRole (_context: AbilitiesContext, {id, role}: {id: string, role: TeamRole}) {
      if (id === '') throw new Error('Can\'t update team role without id.')
      await fb.db.collection(CollectionNames.TEAMS_ROLES).doc(id).set(role.toJSON())
    },
    async deleteRole (_context: AbilitiesContext, id: string) {
      if ( id === '' ) throw new Error('Can\'t delete team role without id.')
      const team = store.state.team.team
      const members = Object.values(team.members).filter(member => member.role === id)
      if (members.length > 0) throw new Error(`There are ${members.length} member(s) assigned to this role`)
      await fb.db.collection(CollectionNames.TEAMS_ROLES).doc(id).set({ deleted: true }, { merge: true })
    }
  },
  mutations: {
    updateTeamRoles (state: AbilitiesState, snap: firestore.QuerySnapshot) {
      state.teamRoles = {}
      state.teamRolesReady = true
      snap.docs.forEach((doc) => {
        const data = doc.data()
        const id = doc.id
        try {
          const ability = new TeamRole(data)
          Vue.set(state.teamRoles, id, ability)
        } catch (error) {
          console.warn(`Could not parse Team Role ${id}: ${error}`)
        }
      })
    }
  }
} as const

export default abilitiesModule
export const abilitiesModuleActionContext = context => moduleActionContext(context, abilitiesModule)
